import { render, staticRenderFns } from "./Leaver.vue?vue&type=template&id=56b82cdf&"
import script from "./Leaver.vue?vue&type=script&lang=js&"
export * from "./Leaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports